<app-interview-sidebar>
  <div class="pricing-page full-width vertical">
    <div class="page-header full-width horizontal seperate bottom">
      <div>
        <div class="page-title margin-top vertical">Get More Points</div>
      </div>
    </div>

    <div class="basic-block">
      <stripe-pricing-table
        [attr.pricing-table-id]="getPricingTableId()"
        [attr.publishable-key]="getKey()"
        [attr.client-reference-id]="getClientReferenceId()"
      >
      </stripe-pricing-table>
    </div>
  </div>
</app-interview-sidebar>
